<template>
  <div :id="this._uid" style="display: none">
  </div>
</template>
<script type="text/babel">
  import GoogleMapChildren from './GoogleMapChildren'

  export default {
    name: 'GoogleMapPolygon',
    extends: GoogleMapChildren,

    methods: {
      init: function () {
        if (this.$parent.ready && this.item == null) {
          var self = this

          this.item = new google.maps.Polygon({
            path: self.positions,
            strokeColor: self.color,
            strokeOpacity: 1.0,
            strokeWeight: 2,
            fillColor: self.fillColor,
            fillOpacity: 0.35,
          })

          this.item.setMap(this.getMap())
        }
      },
    },
    watch: {
      positions: function (n, o) {
        this.item.setPath(this.positions)
      },
      fillColor: function (n, o) {
        this.item.setOptions({fillColor: this.fillColor})
      },
      color: function (n, o) {
        this.item.setOptions({strokeColor: this.color})
      },
    },

    props: {
      positions: {
        type: Array,
        required: true,
      },
      color: {
        type: String,
        default: '#FF0000',
      },
      fillColor: {
        type: String,
        default: '#FF0000',
      },
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// GoogleMapPolygon.vue?bf51a4f4